!(function (modObj) {
    modObj.makeLookup = function makeLookup(_, Device, schemeSettings, getParameterByName, prefix) {
        let schemeId = _.get(schemeSettings, "globals.schemeId")
        return async function (regData) {
            try {
                let pendingResponses = []

                let lookupQueryParams = _.get(schemeSettings, "globals." + prefix + "QueryParameters") || []

                for (let queryParams of lookupQueryParams) {
                    let from = queryParams.from
                    let to = queryParams.to || from
                    let value = getParameterByName(from) || queryParams.default

                    if (queryParams.map) {
                        if (typeof queryParams.map[value] == "undefined") {
                            continue
                        }

                        value = queryParams.map[value]
                    }

                    if (queryParams.validation) {
                        if (queryParams.validation.truthy && !value) {
                            continue
                        }
                    }

                    regData[to] = value
                }

                let lookupLookups = _.get(schemeSettings, "globals." + prefix +"Lookups") || []
                    
                async function doLookup(staticLookup) {
                    let hmacFields = staticLookup.hmacFields || []
                    let result

                    if (hmacFields.length) {
                        let fields = hmacFields.reduce(function (acc, field) {
                            acc[field] = regData[field]
                            return acc
                        }, {})
                        result = await Device.gtp("static-lookup/rows/" + schemeId + "/" + staticLookup.bucket + "/" + staticLookup.folder + "/" + regData[staticLookup.keyField], fields)
                    } else {
                        result = await Device.gtp("static-lookup/rows/" + schemeId + "/" + staticLookup.bucket + "/" + staticLookup.folder + "/" + regData[staticLookup.keyField])
                    }

                    if (result.rows && result.rows.length > 0) {
                        let row = result.rows[0]

                        Object.keys(staticLookup.map).forEach(function (column) {
                            regData[staticLookup.map[column]] = row[column]
                        })

                        if(schemeSettings.globals.updateScreenNameFrom){
                            regData["screenName"] = regData[schemeSettings.globals.updateScreenNameFrom]
                        }

                        if (staticLookup.hmacParameter) {
                            let nonceSig = row.slice(row.length - 2)
                            regData[staticLookup.hmacParameter] = { signature : nonceSig[1], nonce : nonceSig[0] }
                        }
                    }
                }

                for (let staticLookup of lookupLookups) {
                    let lookupProcess = doLookup(staticLookup)

                    if (staticLookup.async) {
                        pendingResponses.push(lookupProcess)
                    } else {
                        await lookupProcess
                    }
                }

                let lookupServices = _.get(schemeSettings, "globals." + prefix + "Services") || []
                async function doService(service) {
                    let serviceData = {};

                    _.assign(serviceData, regData);

                    (service.queryParameters || []).forEach(function (param) {
                        serviceData[param] = getParameterByName(param)
                    });

                    let result = await Device.gtp("web-service/" + schemeId + "/" + service.service, serviceData, "POST");

                    _.assign(regData, result);

                    return regData
                }


                for (let service of lookupServices) {
                    let serviceData = {};

                    _.assign(serviceData, regData);

                    (service.queryParameters || []).forEach(function (param) {
                        serviceData[param] = getParameterByName(param)
                    });

                    let result = await Device.gtp("web-service/" + schemeId + "/" + service.service, serviceData, "POST");

                    _.assign(regData, result);
                }

                return regData

            } catch (e) {
               e.isLookupError = true
               throw e
            }
        }
    }

    modObj.makeLookup._depends = {
        symbol : "3r/login-api/lookup/makeLookup",
        modules : [
            "_",
            "3r/Device",
            "3r/schemeSettings/webapp",
            "3r/getParameterByName"
        ]
    }

    if (typeof window == "object" && window.ioc) {
        window.ioc.injectAll(modObj)
    }

})(typeof exports == "object" ? exports : {})
/* This comment tricks JSPM into wrapping the file as CommonJs module.
exports.fake
*/